// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"77":"55cf4c1a","282":"e22d9ad5","313":"1d57766c","737":"8c5ed345"}[chunkId] + ".chunk.css";
};